import { YourPolicyForm } from "./Form";
import { useYourPolicy } from "./hooks/useYourPolicy";

export const YourPolicy = () => {
  const props = useYourPolicy();
  return <YourPolicyForm {...props} />;
};

export default YourPolicy;
